var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showModal,
          expression: "showModal"
        }
      ],
      staticClass: "cookie-banner",
      attrs: { id: "cookie-banner" }
    },
    [
      !_vm.showManageCookies
        ? _c("div", { staticClass: "container" }, [
            !_vm.mietmich && !_vm.itr && !_vm.erotikum && !_vm.peppr
              ? _c("div", { staticClass: "logo" }, [
                  _c("img", {
                    attrs: { src: "/images/erobella_logo_white.svg" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.mietmich && !_vm.itr
              ? _c("div", { staticClass: "logo" }, [
                  _c("img", { attrs: { src: "/images/ebmm.png" } })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.itr && !_vm.mietmich && _vm.erotikum
              ? _c("div", { staticClass: "logo" }, [
                  _c("img", { attrs: { src: "/images/erotikum/erotikum.svg" } })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.erotikum && _vm.itr
              ? _c("div", { staticClass: "logo" }, [
                  _c("img", { attrs: { src: "/images/itr/ebintimeslogo.png" } })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.itr && !_vm.mietmich && !_vm.erotikum && _vm.peppr
              ? _c("div", { staticClass: "logo" }, [
                  _c("img", { attrs: { src: "/images/peppr/pepprlogo.svg" } })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.mietmich && !_vm.itr
                ? _c("p", [
                    _vm._v(
                      "MietMich wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.itr
                ? _c("p", [
                    _vm._v(
                      "Intimes Revier wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.erotikum
                ? _c("p", [
                    _vm._v(
                      "Erotikum wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.itr && !_vm.mietmich && !_vm.erotikum && _vm.peppr
                ? _c("p", [
                    _vm._v(
                      "Peppr wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.translate.cookie_banner.bannerText2))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "actions" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-secondary full-width d-flex flex-column",
                  attrs: { onclick: "closeCookie()" },
                  on: {
                    click: function($event) {
                      return _vm.onMainButtonClick()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.translate.cookie_banner.ageConsent))
                  ]),
                  _vm._v(" "),
                  !_vm.hasCookiesSavedInStorage()
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.translate.cookie_banner.allowAllCookies)
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sub-actions" }, [
                _c(
                  "span",
                  {
                    attrs: { "e2e-id": "adjust-cookie-settings" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.showManageCookiesMenu()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.translate.cookie_banner.manageCookieButton)
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "leave-link",
                    attrs: { onclick: "cookiesLeavePage()" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onLeaveClick()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.translate.cookie_banner.leaveButton))]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showManageCookies
        ? _c("div", { staticClass: "container manage-cookies" }, [
            _c(
              "div",
              { staticClass: "d-flex flex-column justify-content-center" },
              [
                _c("h5", [
                  _vm._v(_vm._s(_vm.translate.cookie_banner.manageCookieTitle))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.translate.cookie_banner.manageCookieSubtitle)
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary mt-2 mt-sm-3",
                    on: {
                      click: function($event) {
                        return _vm.allowAllCookiesFromOptions()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.translate.cookie_banner.allowAllButton) +
                        "\n            "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "manage-cookies-entry-wrap mt-3 mt-sm-5" },
              [
                _c("div", { staticClass: "manage-cookies-entry" }, [
                  _c("div", { staticClass: "toggle-checkbox" }, [
                    _c("input", {
                      attrs: {
                        type: "checkbox",
                        id: "technology",
                        disabled: ""
                      },
                      domProps: { checked: true }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "technology" } }, [
                      _vm._v(
                        _vm._s(_vm.translate.cookie_banner.technology["title"])
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      _vm._s(_vm.translate.cookie_banner.technology["details"])
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "manage-cookies-entry" }, [
                  _c("div", { staticClass: "toggle-checkbox" }, [
                    _c("input", {
                      attrs: { type: "checkbox", id: "functional" },
                      domProps: { checked: _vm.allowFunctional === true },
                      on: {
                        click: function($event) {
                          return _vm.toggleAllowFunctional()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "functional" } }, [
                      _vm._v(
                        _vm._s(_vm.translate.cookie_banner.functional["title"])
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      _vm._s(_vm.translate.cookie_banner.functional["details"])
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "manage-cookies-entry" }, [
                  _c("div", { staticClass: "toggle-checkbox" }, [
                    _c("input", {
                      attrs: { type: "checkbox", id: "marketing" },
                      domProps: { checked: _vm.allowMarketing === true },
                      on: {
                        click: function($event) {
                          return _vm.toggleAllowMarketing()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "marketing" } }, [
                      _vm._v(
                        _vm._s(_vm.translate.cookie_banner.marketing["title"])
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      _vm._s(_vm.translate.cookie_banner.marketing["details"])
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-center mt-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary save-btn",
                  class: { disabled: !_vm.hasTouchedAnyCookiesToggle },
                  attrs: { "e2e-id": "secondary-cookie-save-btn" },
                  on: {
                    click: function($event) {
                      return _vm.saveSelectedCookiesFromOptions()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.translate.cookie_banner.SaveAndContinueButton) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0779968c", { render: render, staticRenderFns: staticRenderFns })
  }
}